var exports = {
  "k": "x61f99309--4749d8--container",
};

module.exports = exports;
